import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";
import { Classificazione } from 'src/app/common/models/classificazione';
import { SezioneEsitiResponse } from 'src/app/common/models/dto/sezione-esiti-response';
import { Esito } from 'src/app/common/models/esito';
import { FascicoloFull } from 'src/app/common/models/fascicolo/fascicolo-full';
import { PraticaFull } from 'src/app/common/models/pratica/pratica-full';
import { SchedaRecupero } from 'src/app/common/models/scheda-recupero';
import { SezioneEsitiFull } from 'src/app/common/models/sezioni/sezione-esiti-full';
import { SezioneSchedeRecupero } from 'src/app/common/models/sezioni/sezione-schede-recupero';
import { TipoEsito } from 'src/app/common/models/tipologiche/tipo-esito';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';
import { HelpersService } from "../../../../core/services/helpers.service";
import { OperationsService } from "../../../../core/services/operations.service";
import { Controparte } from "../../../models/controparte";
import { FormValidationService } from "../../../services/form-validation.service";

declare var closeModal: any;
declare var openModal: any;
declare var $: any;

@Component({
    selector: 'div [schede-recupero-mod-add]',
  templateUrl: 'schede-recupero-mod-aggiungi.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class SchedeRecuperoModAggiungi {
  pathSchedeRecuperoUrl: string;
  idSezione: string;
  fascicolo: FascicoloFull;
  idParent: string;
  idPratica: string;
  idSezioneEsiti: string;
  urlSezioneEsiti: string;
  schedaRecuperoForm: FormGroup;
  request: SchedaRecupero;
  edit: boolean;
  inserimento: boolean;
  PROPERTIES_SETTINGS = PropertiesSettings;
  msgNoBeneficiari: string;
  selectAll: boolean = true;
  today: number;
  originalRequest: SchedaRecupero;
  tipoProvvedimentoOptions: TipoEsito[]=[];
  msgNoControparti: string;
  msgNoClassificazioni:string;
  praticaFull: PraticaFull;
  classificazione: Classificazione;

  // toggle html
  visibleToggleAssocia: boolean = false;
  visibleToggleForm: boolean = false;

  esitiAll: Esito[] = [];
  constructor(protected operationService: OperationsService,
              private campiForm: FormBuilder,
              private helpers: HelpersService,
              private formValidationService: FormValidationService,
              private modalNotifyService: ModalNotifyService) {}

  @Output() onReturn: EventEmitter<SezioneSchedeRecupero> = new EventEmitter<SezioneSchedeRecupero>();

  inizializza(pathSchedeRecuperoUrl, idPratica, idSezione, idSezioneEsiti, urlSezioneEsiti, fascicolo, praticaFull, classificazione, idParent, edit = false, request = new SchedaRecupero(null)) {
    this.pathSchedeRecuperoUrl = pathSchedeRecuperoUrl;
    this.idSezione = idSezione;
    this.idSezioneEsiti = idSezioneEsiti;
    this.urlSezioneEsiti = urlSezioneEsiti;
    this.fascicolo = fascicolo;
    this.idParent = idParent;
    this.idPratica = idPratica;
    this.edit = edit;
    this.inserimento =!edit;
    this.praticaFull = praticaFull;
    this.classificazione = classificazione;
    this.request=request;
    this.originalRequest=new SchedaRecupero(request);
    openModal('modalmodaggiungischedarecupero');
    this.createForm(request);
    this.readSezioneEsiti(idSezioneEsiti);
    this.initViewToggle();
    this.populateSelect();
    this.msgNoControparti = 'Nessuna controparte associata';
    this.msgNoBeneficiari = 'Non esistono esiti da associare';
    this.msgNoClassificazioni='Nessuna classificazione associata';
    this.today = + new Date();
  }

  createForm(request=new SchedaRecupero(null)) {
    this.request=new SchedaRecupero(request);
    if(this.inserimento) this.request.dataCreazione = new Date(this.today).toLocaleDateString();
    this.schedaRecuperoForm = this.campiForm.group({
      numeroProvvedimento: [this.request.esito ? this.request.esito.numeroEsito : null],
      provvedimento: [this.request.esito ? this.request.esito.tipoEsito.descrizione : null],
      dataProvvedimento: [this.request.esito ? this.request.esito.dataDeposito : null],
      posizione: [this.praticaFull.posizione],
      societa: [(this.classificazione && this.classificazione.materia) ? this.classificazione.materia.label : ''],
      materia: [(this.classificazione && this.classificazione.oggetto) ? this.classificazione.oggetto.label : ''],
      argomento: [(this.classificazione && this.classificazione.argomento) ? this.classificazione.argomento.label : ''],
      controparti: [this.request.controparti],
      descrizione: [this.request.descrizione],
      note: [this.request.note]
    });
    // if(request.esito && this.edit){
    //   this.getContropartiBySocietaEsito(request.esito.societa.id);
    // }
  }

  resetForm(){
    this.createForm(this.originalRequest);
  }

  populateSelect(){
    if (this.tipoProvvedimentoOptions.length === 0) {
      this.helpers.getTipiEsiti().subscribe(response => this.tipoProvvedimentoOptions = response);
    }
  }

  getClassificazioniEsito():Classificazione[]{
    let classificazioniOptions:Classificazione[]=[];
    if(this.request.esito){
      this.request.esito.dettagliEsito.forEach(dettaglio=>{
          if(!classificazioniOptions.find(el=>el.id===dettaglio.classificazione.id)) classificazioniOptions.push(dettaglio.classificazione);
      })
    }
    return classificazioniOptions;
  }

  getContropartiEsito():Controparte[]{
    let controparteOptions:Controparte[]=[];
    if(this.request.esito){
      this.request.esito.dettagliEsito.forEach(dettaglio=>{
          if(!controparteOptions.find(el=>el.id===dettaglio.controparte.id)) controparteOptions.push(dettaglio.controparte);
      })
    }
    return controparteOptions;
  }

  manageModal(sezione: SezioneSchedeRecupero) {
      this.createForm();
      closeModal('modalmodaggiungischedarecupero');
      this.onReturn.emit(sezione);
  }

  initViewToggle() {
      this.visibleToggleAssocia = false;
      this.visibleToggleForm = true;
   if (this.inserimento) {
      this.visibleToggleAssocia = true;
      this.visibleToggleForm = false;
    }
  }

  readSezioneEsiti(idSezioneEsiti: string) {
    if (idSezioneEsiti) {
      this.operationService.readSezione(this.urlSezioneEsiti, idSezioneEsiti)
        .subscribe(response =>
          this.readSezioneEsitiResponse((<SezioneEsitiResponse>response).sezione));
    }
  }

  readSezioneEsitiResponse(sezioneLegali: SezioneEsitiFull) {
    this.esitiAll = sezioneLegali.esiti;
  }

  associaEsito(esito: Esito) {
    this.getEsito(esito);
    this.visibleToggleAssocia = false;
    this.visibleToggleForm = true;
  }

  getEsito(obj: Esito) {
      this.request.esito = this.esitiAll.filter(el => { return el.id === obj.id; })[0];
      this.originalRequest.esito = this.esitiAll.filter(el => { return el.id === obj.id; })[0];
      if(obj.societa) this.getContropartiBySocietaEsito(obj.societa.id);
  }

  getContropartiBySocietaEsito(idSocieta){
     this.operationService.getContropartiBySocieta(idSocieta, this.fascicolo.id).subscribe(res=>{
       this.request.controparti=res;
       this.originalRequest.controparti=res;
     });
  }

  update() {
    if (this.edit) {
      this.operationService.updateSchedaRecupero(this.request, this.pathSchedeRecuperoUrl, this.idSezione, this.fascicolo.id).subscribe(
        response => {
          this.onReturn.emit(<SezioneSchedeRecupero> response.sezione);
          this.modalNotifyService.customMessage("L'operazione è andata a buon fine.");
          closeModal('modalmodaggiungischedarecupero');
        });
    } else {
      this.operationService.addSchedaRecupero(this.request, this.pathSchedeRecuperoUrl, this.idSezione, this.fascicolo.id).subscribe(
        response => {
          console.log(response);
          this.onReturn.emit(<SezioneSchedeRecupero> response.sezione);
          this.modalNotifyService.customMessage("L'operazione è andata a buon fine.");
          closeModal('modalmodaggiungischedarecupero');
        });
    }
  }
}
